import React from 'react'
import { Input as ShadcnInput } from '../ui/Input'
import { cn } from '@/lib/utils'

interface PhoneInputProps {
  id?: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  disabled?: boolean
  className?: string
  label?: string
  error?: string
  required?: boolean
}

export const PhoneInput: React.FC<PhoneInputProps> = ({
  id,
  value,
  onChange,
  placeholder = '(00) 00000-0000',
  disabled = false,
  className = '',
  label,
  error,
  required,
}) => {
 const formatPhone = (value: string): string => {
 // Remove tudo que não é número
 const numbers = value.replace(/\D/g, '')
 
 // Limita a 11 dígitos
 const limited = numbers.substring(0, 11)
 
 // Aplica máscara
 if (limited.length <= 2) {
 return limited
 } else if (limited.length <= 7) {
 return `(${limited.substring(0, 2)}) ${limited.substring(2)}`
 } else if (limited.length <= 11) {
 return `(${limited.substring(0, 2)}) ${limited.substring(2, 7)}-${limited.substring(7)}`
 }
 
 return limited
 }

 const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
 const formatted = formatPhone(e.target.value)
 onChange(formatted)
 }

const inputElement = (
    <ShadcnInput
      id={id}
      type="text"
      inputMode="tel"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
      className={cn(className, error && 'border-red-500 focus:ring-red-500')}
    />
  )

  if (label || error) {
    return (
      <div className="space-y-1">
        {label && (
          <div>
            <label htmlFor={id} className="text-sm font-medium text-foreground">
              {label}
            </label>
            {required && <span className="ml-1 text-sm text-destructive" aria-hidden="true">*</span>}
          </div>
        )}
        {inputElement}
        {error && (
          <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
        )}
      </div>
    )
  }

  return inputElement
}

